function toParagraph(text: string) {
  const lines = text.split('\n');
  let result = '';
  for (const line of lines) {
    result += `<p>${line}</p>`;
  }
  return result;
}

const slideOne = {
      title: 'View One',
      image: 'assets/img/slide-1.jpg',
      thumb: 'assets/img/slide-1.jpg',
      hotspots: [
        {
          title: 'Hoshizaki Alliance - One Partner. Complete Solutions.',
          number: 1,
          coordinates: {
            top: '15%',
            left: '64%'
          },
          link: 'https://hoshizakialliance.com/',
          linkTitle: 'Learn More',
          content: toParagraph('The Hoshizaki Alliance brings together industry-leading brands to deliver a comprehensive approach to foodservice operations. By combining specialized expertise across refrigeration, ice systems, merchandising, food preservation, and preparation, we provide integrated solutions designed to streamline operations, maximize performance, and support long-term success. It\'s everything you need to build a more efficient, reliable, and profitable operation.'),
          images: ['assets/img/HoshizakiAlliance-STAG-quilt.png'],
        },
        {
          title: 'Structural Concepts Autonomous Retail Merchandiser (ARM)',
          number: 2,
          coordinates: {
            top: '45%',
            left: '49%'
          },
          link: 'https://structuralconcepts.com/arm',
          linkTitle: 'Learn More',
          content: toParagraph('Expand retail opportunities with the ARM platform, featuring <strong>ARM XL</strong> for high-volume locations and <strong>ARM SLIM</strong> for compact footprints. With frictionless checkout, real-time inventory visibility, and 24/7 access to fresh food and beverages, ARM helps convenience retailers drive revenue, improve efficiency, and respond to changing consumer expectations.'),
          images: ['https://djnnwndagrfti.cloudfront.net/resources/Shared/ARM/SD2826IS-DUO_BD3632IS-1.png','https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/EV-BD3632-IS-EV.png','https://djnnwndagrfti.cloudfront.net/resources/SD2826IS/ARM-Slim-EV.png'],
          videos: ['W6PZPJM6IpM']
        },
        {
          title: 'Structural Concepts Fusion MD Models',
          number: 3,
          coordinates: {
            top: '41%',
            left: '65%'
          },
          link: 'https://djnnwndagrfti.cloudfront.net/resources/Shared/Fusion/Fusion-MD-Flyer.pdf',
          linkTitle: 'Learn More',
          content: toParagraph('The spacious Fusion MD fresh food merchandiser delivers unmatched merchandising capacity — ideal for high-traffic environments where reduced refill frequency is key. Its self-service, open reach-in design promotes easy access to an expansive variety of fresh offerings, while an optional doored version adds flexibility for settings that require added temperature control or customization.'),
          images: ['https://djnnwndagrfti.cloudfront.net/resources/MD485DR-MD685DR/MD485DR_Supermarket_Web.png','https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R_Hilton_Unit-3.jpg','https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R-2/MD485R_DR5303_MD485R_ENVIRO_03-12-26.png']
        },
        {
          title: 'Structural Concepts Digital Merchandiser (DM Series)',
          number: 4,
          coordinates: {
            top: '45%',
            left: '75%'
          },
          link: 'https://djnnwndagrfti.cloudfront.net/resources/DM476R-Flyer.pdf',
          linkTitle: 'Learn More',
          content: toParagraph('Be among the first to experience the Digital Merchandiser (DM Series), the latest innovation from Structural Concepts. Combining refrigerated merchandising with an integrated digital display, the DM Series makes it easy to showcase products and update promotions in real time. Designed for today\'s fast-changing retail environments, this smart solution helps operators engage shoppers, simplify content management, and maximize merchandising impact.'),
        },
        {
          title: 'Structural Concepts The Blend® Collection',
          number: 5,
          coordinates: {
            top: '75%',
            left: '65%'
          },
          link: 'https://djnnwndagrfti.cloudfront.net/resources/Shared/Blend/SCC_Collection_Brochures_Blend_Web.pdf',
          linkTitle: 'Learn More',
          content: toParagraph('The Blend® Collection is a modular, multi-temperature island that seamlessly combines refrigerated, heated, and ambient merchandising into one flexible display solution. Designed to maximize cross-merchandising opportunities, adapt to changing consumer trends, and elevate the fresh food experience, Blend helps convenience retailers create a destination shoppers can\'t miss. Explore Blend in our virtual booth today.'),
          images: ['https://djnnwndagrfti.cloudfront.net/resources/NM7255DSSV/NM7255DSSV-Supermarket.jpg','https://djnnwndagrfti.cloudfront.net/resources/NM7255RSSA/NM7255RSSA_NM4855RSSV_20251112_081339-1.jpg '],
          videos: ['4VhxvHBTZkQ']
        },
        {
          title: 'Structural Concepts FreshWatch™',
          number: 6,
          coordinates: {
            top: '33%',
            left: '33%'
          },
          link: 'https://djnnwndagrfti.cloudfront.net/resources/Shared/FreshWatch-Flyer.pdf ',
          linkTitle: 'Learn More',
          content: toParagraph('FreshWatch™ is an advanced cloud-based platform that gives operators complete visibility into their equipment performance through real-time monitoring, remote diagnostics, and energy optimization. Proactive alerts and actionable insights help protect food quality, reduce waste, minimize downtime, and lower operating costs, empowering businesses to operate more efficiently and profitably.'),
          videos: ['EzBs2f1soKw']
        },
        {
          title: 'Structural Concepts Refrigerated Self-Service Case with Rear Ambient Shelving',
          number: 7,
          coordinates: {
            top: '65%',
            left: '20%'
          },
          link: 'https://structuralconcepts.com/products/nm4852rssa',
          linkTitle: 'Learn More',
          content: toParagraph('Refrigerated Self-Service Case with Rear Ambient Shelving combines fresh food merchandising and convenient ambient storage in one space-saving solution. Configurable angled or flat deck merchandising adapts easily to changing product assortments, while rear shelving adds capacity and operational efficiency. Energy-efficient LED lighting and self-contained R290 refrigeration create an attractive, highly shopable display for produce, grab-and-go meals, and fresh foods in supermarkets, convenience stores, and other retail environments.'),
          images: ['https://djnnwndagrfti.cloudfront.net/resources/NM4852RSSA/PRODUCE-PRO-NM4852RSSA-2-4-8-2026.jpg','https://djnnwndagrfti.cloudfront.net/resources/NM4852RSSA/PRODUCE-PRO-NM4852RSSA-4-8-2026.jpg'],
        },
      ]
};

const slideTwo = {
  title: 'View Two',
  image: 'assets/img/slide-2.jpg',
  thumb: 'assets/img/slide-2.jpg',
  hotspots: [
    {
      title: 'Hoshizaki Alliance - One Partner. Complete Solutions.',
      number: 1,
      coordinates: {
        top: '15%',
        left: '60%'
      },
      link: 'https://hoshizakialliance.com/',
      linkTitle: 'Learn More',
      content: toParagraph('The Hoshizaki Alliance brings together industry-leading brands to deliver a comprehensive approach to foodservice operations. By combining specialized expertise across refrigeration, ice systems, merchandising, food preservation, and preparation, we provide integrated solutions designed to streamline operations, maximize performance, and support long-term success. It\'s everything you need to build a more efficient, reliable, and profitable operation.'),
      images: ['assets/img/HoshizakiAlliance-STAG-quilt.png'],
    },
    {
      title: 'Structural Concepts Autonomous Retail Merchandiser (ARM)',
      number: 2,
      coordinates: {
        top: '46%',
        left: '75%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'Learn More',
      content: toParagraph('Expand retail opportunities with the ARM platform, featuring <strong>ARM XL</strong> for high-volume locations and <strong>ARM SLIM</strong> for compact footprints. With frictionless checkout, real-time inventory visibility, and 24/7 access to fresh food and beverages, ARM helps convenience retailers drive revenue, improve efficiency, and respond to changing consumer expectations.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/Shared/ARM/SD2826IS-DUO_BD3632IS-1.png','https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/EV-BD3632-IS-EV.png','https://djnnwndagrfti.cloudfront.net/resources/SD2826IS/ARM-Slim-EV.png'],
      videos: ['W6PZPJM6IpM']
    },
    {
      title: 'Structural Concepts Fusion MD Models',
      number: 3,
      coordinates: {
        top: '36%',
        left: '53%'
      },
      link: 'https://djnnwndagrfti.cloudfront.net/resources/Shared/Fusion/Fusion-MD-Flyer.pdf',
      linkTitle: 'Learn More',
      content: toParagraph('The spacious Fusion MD fresh food merchandiser delivers unmatched merchandising capacity — ideal for high-traffic environments where reduced refill frequency is key. Its self-service, open reach-in design promotes easy access to an expansive variety of fresh offerings, while an optional doored version adds flexibility for settings that require added temperature control or customization.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/MD485DR-MD685DR/MD485DR_Supermarket_Web.png','https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R/MD485R_Hilton_Unit-3.jpg','https://djnnwndagrfti.cloudfront.net/resources/MD485R-MD685R-2/MD485R_DR5303_MD485R_ENVIRO_03-12-26.png']
    },
    {
      title: 'Structural Concepts Refrigerated Self-Service Case with Rear Ambient Shelving',
      number: 7,
      coordinates: {
        top: '61%',
        left: '39%'
      },
      link: 'https://structuralconcepts.com/products/nm4852rssa',
      linkTitle: 'Learn More',
      content: toParagraph('Refrigerated Self-Service Case with Rear Ambient Shelving combines fresh food merchandising and convenient ambient storage in one space-saving solution. Configurable angled or flat deck merchandising adapts easily to changing product assortments, while rear shelving adds capacity and operational efficiency. Energy-efficient LED lighting and self-contained R290 refrigeration create an attractive, highly shopable display for produce, grab-and-go meals, and fresh foods in supermarkets, convenience stores, and other retail environments.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/NM4852RSSA/PRODUCE-PRO-NM4852RSSA-2-4-8-2026.jpg','https://djnnwndagrfti.cloudfront.net/resources/NM4852RSSA/PRODUCE-PRO-NM4852RSSA-4-8-2026.jpg'],
    },
    {
      title: 'Structural Concepts Q Series',
      number: 8,
      coordinates: {
        top: '52%',
        left: '49%'
      },
      link: 'https://djnnwndagrfti.cloudfront.net/resources/Shared/Oasis/Q-Series-Flyer.pdf',
      linkTitle: 'Learn More',
      content: toParagraph('Offer fresh-made packaged foods in a low-profile, narrow-depth refrigerated merchandiser designed to capture attention and drive grab-and-go purchases. Its open sightlines allow customers to see fresh food being prepared behind the case while providing easy front access for quick, convenient self-service.\n\nStraight and corner merchandisers can be combined to create customized layouts that maximize capacity for each location. The narrow footprint allows for flexible installation in virtually any space, while a wide range of sizes, finishes, and merchandising options makes it easy to tailor the display to your brand and operation.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/Q45N44AR/Q45N44AR_Q344R_DR5243-1_CONVENIENCE_VIZ_UPSCALED_01-15-26.png','https://djnnwndagrfti.cloudfront.net/resources/Q45N44AR/Q45N44AR_Q344R_DR5243-2_MICRO_GROCERY_VIZ_UPSCALED_01-14-25.png','https://djnnwndagrfti.cloudfront.net/resources/Q344R/Q344R_DR5243-3_EDUCATION_VIZ_UPSCALED_01-14-26.png ']
    },
    {
      title: 'Lancer IBD BOLD 30i™',
      number: 10,
      coordinates: {
        top: '44%',
        left: '65%'
      },
      link: 'https://www.lancerworldwide.com/shop/ibd-bold-30i',
      linkTitle: 'View Product',
      content: toParagraph('Lancer®  Worldwide\'s IBD Bold 30i™ is the most advanced beverage dispensing solution on the market today. Equipped with a cutting-edge touchscreen to enhance your beverage dispensing experience, it delivers versatility, aesthetics, and superior beverage quality, all backed by our best-in-class warranty. The IBD Bold 30i™ propels your beverage dispensing into the next generation for a hassle-free and highly profitable ownership experience.\n\n <a href="https://www.lancerworldwide.com/videos/ibd-bold-30i-highlight" target="_blank" class="bg-primary-light hover:bg-white border border-primary-light text-white hover:text-primary rounded-md text-sm p-4 mt-4 w-full flex justify-center items-center transition-colors duration-300">Watch Video</a>'),
    },
    {
      title: 'Hoshizaki Merchandisers',
      number: 13,
      coordinates: {
        top: '57%',
        left: '26%'
      },
      link: 'https://www.hoshizakiamerica.com/industry/c-stores/',
      linkTitle: 'View Products',
      content: toParagraph('Hoshizaki’s energy-efficient glass door merchandiser refrigerators keep beverages, snacks, and perishable items fresh and easily accessible. Designed for maximum visibility and reliable cooling, they are available in silver, black, or white to suit any environment. Choose from compact countertop to one-, two-, or three-section models to match your space and storage needs.'),
      videos: ['-Za--0IAFo8']
    },
  ]
};

const slideThree = {
  title: 'View Three',
  image: 'assets/img/slide-3.jpg',
  thumb: 'assets/img/slide-3.jpg',
  hotspots: [
    {
      title: 'Hoshizaki Alliance - One Partner. Complete Solutions.',
      number: 1,
      coordinates: {
        top: '15%',
        left: '64%'
      },
      link: 'https://hoshizakialliance.com/',
      linkTitle: 'Learn More',
      content: toParagraph('The Hoshizaki Alliance brings together industry-leading brands to deliver a comprehensive approach to foodservice operations. By combining specialized expertise across refrigeration, ice systems, merchandising, food preservation, and preparation, we provide integrated solutions designed to streamline operations, maximize performance, and support long-term success. It\'s everything you need to build a more efficient, reliable, and profitable operation.'),
      images: ['assets/img/HoshizakiAlliance-STAG-quilt.png'],
    },
    {
      title: 'Structural Concepts Digital Merchandiser (DM Series)',
      number: 4,
      coordinates: {
        top: '37%',
        left: '51%'
      },
      link: 'https://djnnwndagrfti.cloudfront.net/resources/DM476R-Flyer.pdf',
      linkTitle: 'Learn More',
      content: toParagraph('Be among the first to experience the Digital Merchandiser (DM Series), the latest innovation from Structural Concepts. Combining refrigerated merchandising with an integrated digital display, the DM Series makes it easy to showcase products and update promotions in real time. Designed for today\'s fast-changing retail environments, this smart solution helps operators engage shoppers, simplify content management, and maximize merchandising impact.'),
    },
    {
      title: 'Structural Concepts Refrigerated Self-Service Case with Rear Ambient Shelving',
      number: 7,
      coordinates: {
        top: '60%',
        left: '62%'
      },
      link: 'https://structuralconcepts.com/products/nm4852rssa',
      linkTitle: 'Learn More',
      content: toParagraph('Refrigerated Self-Service Case with Rear Ambient Shelving combines fresh food merchandising and convenient ambient storage in one space-saving solution. Configurable angled or flat deck merchandising adapts easily to changing product assortments, while rear shelving adds capacity and operational efficiency. Energy-efficient LED lighting and self-contained R290 refrigeration create an attractive, highly shopable display for produce, grab-and-go meals, and fresh foods in supermarkets, convenience stores, and other retail environments.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/NM4852RSSA/PRODUCE-PRO-NM4852RSSA-2-4-8-2026.jpg','https://djnnwndagrfti.cloudfront.net/resources/NM4852RSSA/PRODUCE-PRO-NM4852RSSA-4-8-2026.jpg'],
    },
    {
      title: 'Structural Concepts Q Series',
      number: 8,
      coordinates: {
        top: '52%',
        left: '52%'
      },
      link: 'https://djnnwndagrfti.cloudfront.net/resources/Shared/Oasis/Q-Series-Flyer.pdf',
      linkTitle: 'Learn More',
      content: toParagraph('Offer fresh-made packaged foods in a low-profile, narrow-depth refrigerated merchandiser designed to capture attention and drive grab-and-go purchases. Its open sightlines allow customers to see fresh food being prepared behind the case while providing easy front access for quick, convenient self-service.\n\nStraight and corner merchandisers can be combined to create customized layouts that maximize capacity for each location. The narrow footprint allows for flexible installation in virtually any space, while a wide range of sizes, finishes, and merchandising options makes it easy to tailor the display to your brand and operation.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/Q45N44AR/Q45N44AR_Q344R_DR5243-1_CONVENIENCE_VIZ_UPSCALED_01-15-26.png','https://djnnwndagrfti.cloudfront.net/resources/Q45N44AR/Q45N44AR_Q344R_DR5243-2_MICRO_GROCERY_VIZ_UPSCALED_01-14-25.png','https://djnnwndagrfti.cloudfront.net/resources/Q344R/Q344R_DR5243-3_EDUCATION_VIZ_UPSCALED_01-14-26.png ']
    },
    {
      title: 'Lancer IBD BOLD 30i™',
      number: 10,
      coordinates: {
        top: '32%',
        left: '72%'
      },
      link: 'https://www.lancerworldwide.com/shop/ibd-bold-30i',
      linkTitle: 'View Product',
      content: toParagraph('Lancer®  Worldwide\'s IBD Bold 30i™ is the most advanced beverage dispensing solution on the market today. Equipped with a cutting-edge touchscreen to enhance your beverage dispensing experience, it delivers versatility, aesthetics, and superior beverage quality, all backed by our best-in-class warranty. The IBD Bold 30i™ propels your beverage dispensing into the next generation for a hassle-free and highly profitable ownership experience.\n\n <a href="https://www.lancerworldwide.com/videos/ibd-bold-30i-highlight" target="_blank" class="bg-primary-light hover:bg-white border border-primary-light text-white hover:text-primary rounded-md text-sm p-4 mt-4 w-full flex justify-center items-center transition-colors duration-300">Watch Video</a>'),
    },
    {
      title: 'Lancer Flavor Select 30”',
      number: 11,
      coordinates: {
        top: '47%',
        left: '36%'
      },
      link: 'https://www.lancerworldwide.com/shop/flavor-select-30?variant=53190952157550#image-1',
      linkTitle: 'View Product',
      content: toParagraph('The Flavor Select® (FS) combines industry-leading cold carbonation technology with up to 200 customizable flavor combinations to deliver a refreshing, consistent beverage experience every time. Designed for operational flexibility, the dispenser can be configured to dispense either cube or cubelet ice, helping operators tailor their offering to customer preferences.'),
    },
    {
      title: 'Hoshizaki Merchandisers',
      number: 13,
      coordinates: {
        top: '64%',
        left: '44%'
      },
      link: 'https://www.hoshizakiamerica.com/industry/c-stores/',
      linkTitle: 'View Products',
      content: toParagraph('Hoshizaki’s energy-efficient glass door merchandiser refrigerators keep beverages, snacks, and perishable items fresh and easily accessible. Designed for maximum visibility and reliable cooling, they are available in silver, black, or white to suit any environment. Choose from compact countertop to one-, two-, or three-section models to match your space and storage needs.'),
      videos: ['-Za--0IAFo8']
    },
    {
      title: 'Jackson DynaStar® HH-E VER',
      number: 14,
      coordinates: {
        top: '55%',
        left: '21%'
      },
      link: 'https://www.jacksonwws.com/products/dynastar-hh-e-with-ventless-energy-recovery/',
      linkTitle: 'View Product',
      content: toParagraph('Perfect for C-stores with foodservice programs, the DynaStar® HH-E VER delivers powerful ventless warewashing without requiring a traditional hood. Its tall chamber, dual dishwasher/potwasher certification, high-temperature sanitizing, and exclusive Smart Vent technology deliver clean, sanitized ware while making the most of limited back-of-house space.'),
    },
  ]
};

const slideFour = {
  title: 'View Four',
  image: 'assets/img/slide-4.jpg',
  thumb: 'assets/img/slide-4.jpg',
  hotspots: [
    {
      title: 'Hoshizaki Alliance - One Partner. Complete Solutions.',
      number: 1,
      coordinates: {
        top: '15%',
        left: '60%'
      },
      link: 'https://hoshizakialliance.com/',
      linkTitle: 'Learn More',
      content: toParagraph('The Hoshizaki Alliance brings together industry-leading brands to deliver a comprehensive approach to foodservice operations. By combining specialized expertise across refrigeration, ice systems, merchandising, food preservation, and preparation, we provide integrated solutions designed to streamline operations, maximize performance, and support long-term success. It\'s everything you need to build a more efficient, reliable, and profitable operation.'),
      images: ['assets/img/HoshizakiAlliance-STAG-quilt.png'],
    },
    {
      title: 'Structural Concepts Heated & Multi-Temperature Self-Service Cases',
      number: 9,
      coordinates: {
        top: '45%',
        left: '27%'
      },
      link: 'https://structuralconcepts.com/products/?temperature=Heated&collection=Oasis',
      linkTitle: 'Learn View Products',
      content: toParagraph('Create a convenient grab-and-go destination with self-service cases designed for hot and cold food merchandising. Available in heated-only and refrigerated/heated configurations, these versatile solutions maximize menu variety, encourage impulse purchases, and help operators deliver a seamless customer experience in a single footprint.'),
    },
    {
      title: 'Lancer IBD BOLD 30i™',
      number: 10,
      coordinates: {
        top: '33%',
        left: '70%'
      },
      link: 'https://www.lancerworldwide.com/shop/ibd-bold-30i',
      linkTitle: 'View Product',
      content: toParagraph('Lancer®  Worldwide\'s IBD Bold 30i™ is the most advanced beverage dispensing solution on the market today. Equipped with a cutting-edge touchscreen to enhance your beverage dispensing experience, it delivers versatility, aesthetics, and superior beverage quality, all backed by our best-in-class warranty. The IBD Bold 30i™ propels your beverage dispensing into the next generation for a hassle-free and highly profitable ownership experience.\n\n <a href="https://www.lancerworldwide.com/videos/ibd-bold-30i-highlight" target="_blank" class="bg-primary-light hover:bg-white border border-primary-light text-white hover:text-primary rounded-md text-sm p-4 mt-4 w-full flex justify-center items-center transition-colors duration-300">Watch Video</a>'),
    },
    {
      title: 'Lancer Flavor Select 30”',
      number: 11,
      coordinates: {
        top: '44%',
        left: '63%'
      },
      link: 'https://www.lancerworldwide.com/shop/flavor-select-30?variant=53190952157550#image-1',
      linkTitle: 'View Product',
      content: toParagraph('The Flavor Select® (FS) combines industry-leading cold carbonation technology with up to 200 customizable flavor combinations to deliver a refreshing, consistent beverage experience every time. Designed for operational flexibility, the dispenser can be configured to dispense either cube or cubelet ice, helping operators tailor their offering to customer preferences.'),
    },
    {
      title: 'Hoshizaki Hoshizaki Ice Machines for Fresh, Clean Ice',
      number: 12,
      coordinates: {
        top: '45%',
        left: '48%'
      },
      link: 'https://www.hoshizakiamerica.com/industry/c-stores/',
      linkTitle: 'View Products',
      content: toParagraph('Ensure a steady supply of ice with our commercial ice machines, built for convenience stores of all sizes. Our machines deliver crystal-clear ice with advanced filtration and energy-efficient operation—perfect for self-serve beverage stations and cold drink displays.\n\nAdditional offerings include ice and water dispensers, and ice storage bins and stands.'),
      videos: ['-Za--0IAFo8']
    },
    {
      title: 'Hoshizaki Merchandisers',
      number: 13,
      coordinates: {
        top: '64%',
        left: '44%'
      },
      link: 'https://www.hoshizakiamerica.com/industry/c-stores/',
      linkTitle: 'View Products',
      content: toParagraph('Hoshizaki’s energy-efficient glass door merchandiser refrigerators keep beverages, snacks, and perishable items fresh and easily accessible. Designed for maximum visibility and reliable cooling, they are available in silver, black, or white to suit any environment. Choose from compact countertop to one-, two-, or three-section models to match your space and storage needs.'),
      videos: ['-Za--0IAFo8']
    },
    {
      title: 'Jackson DynaStar® HH-E VER',
      number: 14,
      coordinates: {
        top: '55%',
        left: '21%'
      },
      link: 'https://www.jacksonwws.com/products/dynastar-hh-e-with-ventless-energy-recovery/',
      linkTitle: 'View Product',
      content: toParagraph('Perfect for C-stores with foodservice programs, the DynaStar® HH-E VER delivers powerful ventless warewashing without requiring a traditional hood. Its tall chamber, dual dishwasher/potwasher certification, high-temperature sanitizing, and exclusive Smart Vent technology deliver clean, sanitized ware while making the most of limited back-of-house space.'),
    },
  ]
};

const slideFive = {
  title: 'View Five',
  image: 'assets/img/slide-5.jpg',
  thumb: 'assets/img/slide-5.jpg',
  hotspots: [
    {
      title: 'Hoshizaki Alliance - One Partner. Complete Solutions.',
      number: 1,
      coordinates: {
        top: '15%',
        left: '62%'
      },
      link: 'https://hoshizakialliance.com/',
      linkTitle: 'Learn More',
      content: toParagraph('The Hoshizaki Alliance brings together industry-leading brands to deliver a comprehensive approach to foodservice operations. By combining specialized expertise across refrigeration, ice systems, merchandising, food preservation, and preparation, we provide integrated solutions designed to streamline operations, maximize performance, and support long-term success. It\'s everything you need to build a more efficient, reliable, and profitable operation.'),
      images: ['assets/img/HoshizakiAlliance-STAG-quilt.png'],
    },
    {
      title: 'Structural Concepts Heated & Multi-Temperature Self-Service Cases',
      number: 9,
      coordinates: {
        top: '52%',
        left: '33%'
      },
      link: 'https://structuralconcepts.com/products/?temperature=Heated&collection=Oasis',
      linkTitle: 'Learn View Products',
      content: toParagraph('Create a convenient grab-and-go destination with self-service cases designed for hot and cold food merchandising. Available in heated-only and refrigerated/heated configurations, these versatile solutions maximize menu variety, encourage impulse purchases, and help operators deliver a seamless customer experience in a single footprint.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/Hoshizaki/Hoshizaki_Web_Environment-1.png'],
      videos: ['W6PZPJM6IpM']
    },
    {
      title: 'Lancer Flavor Select 30”',
      number: 11,
      coordinates: {
        top: '47%',
        left: '77%'
      },
      link: 'https://www.lancerworldwide.com/shop/flavor-select-30?variant=53190952157550#image-1',
      linkTitle: 'View Product',
      content: toParagraph('The Flavor Select® (FS) combines industry-leading cold carbonation technology with up to 200 customizable flavor combinations to deliver a refreshing, consistent beverage experience every time. Designed for operational flexibility, the dispenser can be configured to dispense either cube or cubelet ice, helping operators tailor their offering to customer preferences.'),
    },
    {
      title: 'Hoshizaki Ice Machines for Fresh, Clean Ice',
      number: 12,
      coordinates: {
        top: '47%',
        left: '67%'
      },
      link: 'https://www.hoshizakiamerica.com/industry/c-stores/',
      linkTitle: 'View Products',
      content: toParagraph('Ensure a steady supply of ice with our commercial ice machines, built for convenience stores of all sizes. Our machines deliver crystal-clear ice with advanced filtration and energy-efficient operation—perfect for self-serve beverage stations and cold drink displays.\n\nAdditional offerings include ice and water dispensers, and ice storage bins and stands.'),
      videos: ['-Za--0IAFo8']
    },
    {
      title: 'Hoshizaki Merchandisers',
      number: 13,
      coordinates: {
        top: '50%',
        left: '61%'
      },
      link: 'https://www.hoshizakiamerica.com/industry/c-stores/',
      linkTitle: 'View Products',
      content: toParagraph('Hoshizaki’s energy-efficient glass door merchandiser refrigerators keep beverages, snacks, and perishable items fresh and easily accessible. Designed for maximum visibility and reliable cooling, they are available in silver, black, or white to suit any environment. Choose from compact countertop to one-, two-, or three-section models to match your space and storage needs.'),
      videos: ['-Za--0IAFo8']
    },
    {
      title: 'Jackson DynaStar® HH-E VER',
      number: 14,
      coordinates: {
        top: '63%',
        left: '48%'
      },
      link: 'https://www.jacksonwws.com/products/dynastar-hh-e-with-ventless-energy-recovery/',
      linkTitle: 'View Product',
      content: toParagraph('Perfect for C-stores with foodservice programs, the DynaStar® HH-E VER delivers powerful ventless warewashing without requiring a traditional hood. Its tall chamber, dual dishwasher/potwasher certification, high-temperature sanitizing, and exclusive Smart Vent technology deliver clean, sanitized ware while making the most of limited back-of-house space.'),
    },
  ]
};


const slideSix = {
  title: 'View Six',
  image: 'assets/img/slide-6.jpg',
  thumb: 'assets/img/slide-6.jpg',
  hotspots: [
    {
      title: 'Hoshizaki Alliance - One Partner. Complete Solutions.',
      number: 1,
      coordinates: {
        top: '15%',
        left: '60%'
      },
      link: 'https://hoshizakialliance.com/',
      linkTitle: 'Learn More',
      content: toParagraph('The Hoshizaki Alliance brings together industry-leading brands to deliver a comprehensive approach to foodservice operations. By combining specialized expertise across refrigeration, ice systems, merchandising, food preservation, and preparation, we provide integrated solutions designed to streamline operations, maximize performance, and support long-term success. It\'s everything you need to build a more efficient, reliable, and profitable operation.'),
      images: ['assets/img/HoshizakiAlliance-STAG-quilt.png'],
    },
    {
      title: 'Structural Concepts Refrigerated Self-Service Case with Rear Ambient Shelving',
      number: 7,
      coordinates: {
        top: '40%',
        left: '56%'
      },
      link: 'https://structuralconcepts.com/products/nm4852rssa',
      linkTitle: 'Learn More',
      content: toParagraph('Refrigerated Self-Service Case with Rear Ambient Shelving combines fresh food merchandising and convenient ambient storage in one space-saving solution. Configurable angled or flat deck merchandising adapts easily to changing product assortments, while rear shelving adds capacity and operational efficiency. Energy-efficient LED lighting and self-contained R290 refrigeration create an attractive, highly shopable display for produce, grab-and-go meals, and fresh foods in supermarkets, convenience stores, and other retail environments.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/NM4852RSSA/PRODUCE-PRO-NM4852RSSA-2-4-8-2026.jpg','https://djnnwndagrfti.cloudfront.net/resources/NM4852RSSA/PRODUCE-PRO-NM4852RSSA-4-8-2026.jpg'],
    },
    {
      title: 'Hoshizaki Merchandisers',
      number: 13,
      coordinates: {
        top: '45%',
        left: '70%'
      },
      link: 'https://www.hoshizakiamerica.com/industry/c-stores/',
      linkTitle: 'View Products',
      content: toParagraph('Hoshizaki’s energy-efficient glass door merchandiser refrigerators keep beverages, snacks, and perishable items fresh and easily accessible. Designed for maximum visibility and reliable cooling, they are available in silver, black, or white to suit any environment. Choose from compact countertop to one-, two-, or three-section models to match your space and storage needs.'),
      videos: ['-Za--0IAFo8']
    },
    {
      title: 'Jackson DynaStar® HH-E VER',
      number: 14,
      coordinates: {
        top: '57%',
        left: '81%'
      },
      link: 'https://www.jacksonwws.com/products/dynastar-hh-e-with-ventless-energy-recovery/',
      linkTitle: 'View Product',
      content: toParagraph('Perfect for C-stores with foodservice programs, the DynaStar® HH-E VER delivers powerful ventless warewashing without requiring a traditional hood. Its tall chamber, dual dishwasher/potwasher certification, high-temperature sanitizing, and exclusive Smart Vent technology deliver clean, sanitized ware while making the most of limited back-of-house space.'),
    },
  ]
};

const slideSeven = {
  title: 'View Seven',
  image: 'assets/img/slide-7.jpg',
  thumb: 'assets/img/slide-7.jpg',
  hotspots: [
    {
      title: 'Hoshizaki Alliance - One Partner. Complete Solutions.',
      number: 1,
      coordinates: {
        top: '15%',
        left: '63%'
      },
      link: 'https://hoshizakialliance.com/',
      linkTitle: 'Learn More',
      content: toParagraph('The Hoshizaki Alliance brings together industry-leading brands to deliver a comprehensive approach to foodservice operations. By combining specialized expertise across refrigeration, ice systems, merchandising, food preservation, and preparation, we provide integrated solutions designed to streamline operations, maximize performance, and support long-term success. It\'s everything you need to build a more efficient, reliable, and profitable operation.'),
      images: ['assets/img/HoshizakiAlliance-STAG-quilt.png'],
    },
    {
      title: 'Structural Concepts Autonomous Retail Merchandiser (ARM)',
      number: 2,
      coordinates: {
        top: '33%',
        left: '23%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'Learn More',
      content: toParagraph('Expand retail opportunities with the ARM platform, featuring <strong>ARM XL</strong> for high-volume locations and <strong>ARM SLIM</strong> for compact footprints. With frictionless checkout, real-time inventory visibility, and 24/7 access to fresh food and beverages, ARM helps convenience retailers drive revenue, improve efficiency, and respond to changing consumer expectations.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/Shared/ARM/SD2826IS-DUO_BD3632IS-1.png','https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/EV-BD3632-IS-EV.png','https://djnnwndagrfti.cloudfront.net/resources/SD2826IS/ARM-Slim-EV.png'],
      videos: ['W6PZPJM6IpM']
    },
    {
      title: 'Structural Concepts The Blend® Collection',
      number: 5,
      coordinates: {
        top: '55%',
        left: '33%'
      },
      link: 'https://djnnwndagrfti.cloudfront.net/resources/Shared/Blend/SCC_Collection_Brochures_Blend_Web.pdf',
      linkTitle: 'Learn More',
      content: toParagraph('The Blend® Collection is a modular, multi-temperature island that seamlessly combines refrigerated, heated, and ambient merchandising into one flexible display solution. Designed to maximize cross-merchandising opportunities, adapt to changing consumer trends, and elevate the fresh food experience, Blend helps convenience retailers create a destination shoppers can\'t miss. Explore Blend in our virtual booth today.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/NM7255DSSV/NM7255DSSV-Supermarket.jpg','https://djnnwndagrfti.cloudfront.net/resources/NM7255RSSA/NM7255RSSA_NM4855RSSV_20251112_081339-1.jpg '],
      videos: ['4VhxvHBTZkQ']
    },
  ]
};

const slideEight = {
  title: 'View Eight',
  image: 'assets/img/slide-8.jpg',
  thumb: 'assets/img/slide-8.jpg',
  hotspots: [
    {
      title: 'Hoshizaki Alliance - One Partner. Complete Solutions.',
      number: 1,
      coordinates: {
        top: '15%',
        left: '60%'
      },
      link: 'https://hoshizakialliance.com/',
      linkTitle: 'Learn More',
      content: toParagraph('The Hoshizaki Alliance brings together industry-leading brands to deliver a comprehensive approach to foodservice operations. By combining specialized expertise across refrigeration, ice systems, merchandising, food preservation, and preparation, we provide integrated solutions designed to streamline operations, maximize performance, and support long-term success. It\'s everything you need to build a more efficient, reliable, and profitable operation.'),
      images: ['assets/img/HoshizakiAlliance-STAG-quilt.png'],
    },
    {
      title: 'Structural Concepts Autonomous Retail Merchandiser (ARM)',
      number: 2,
      coordinates: {
        top: '40%',
        left: '27%'
      },
      link: 'https://structuralconcepts.com/arm',
      linkTitle: 'Learn More',
      content: toParagraph('Expand retail opportunities with the ARM platform, featuring <strong>ARM XL</strong> for high-volume locations and <strong>ARM SLIM</strong> for compact footprints. With frictionless checkout, real-time inventory visibility, and 24/7 access to fresh food and beverages, ARM helps convenience retailers drive revenue, improve efficiency, and respond to changing consumer expectations.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/Shared/ARM/SD2826IS-DUO_BD3632IS-1.png','https://djnnwndagrfti.cloudfront.net/resources/BD3632IS/EV-BD3632-IS-EV.png','https://djnnwndagrfti.cloudfront.net/resources/SD2826IS/ARM-Slim-EV.png'],
      videos: ['W6PZPJM6IpM']
    },
    {
      title: 'Structural Concepts Digital Merchandiser (DM Series)',
      number: 4,
      coordinates: {
        top: '53%',
        left: '67%'
      },
      link: 'https://djnnwndagrfti.cloudfront.net/resources/DM476R-Flyer.pdf',
      linkTitle: 'Learn More',
      content: toParagraph('Be among the first to experience the Digital Merchandiser (DM Series), the latest innovation from Structural Concepts. Combining refrigerated merchandising with an integrated digital display, the DM Series makes it easy to showcase products and update promotions in real time. Designed for today\'s fast-changing retail environments, this smart solution helps operators engage shoppers, simplify content management, and maximize merchandising impact.'),
    }, 
    {
      title: 'Structural Concepts The Blend® Collection',
      number: 5,
      coordinates: {
        top: '58%',
        left: '50%'
      },
      link: 'https://djnnwndagrfti.cloudfront.net/resources/Shared/Blend/SCC_Collection_Brochures_Blend_Web.pdf',
      linkTitle: 'Learn More',
      content: toParagraph('The Blend® Collection is a modular, multi-temperature island that seamlessly combines refrigerated, heated, and ambient merchandising into one flexible display solution. Designed to maximize cross-merchandising opportunities, adapt to changing consumer trends, and elevate the fresh food experience, Blend helps convenience retailers create a destination shoppers can\'t miss. Explore Blend in our virtual booth today.'),
      images: ['https://djnnwndagrfti.cloudfront.net/resources/NM7255DSSV/NM7255DSSV-Supermarket.jpg','https://djnnwndagrfti.cloudfront.net/resources/NM7255RSSA/NM7255RSSA_NM4855RSSV_20251112_081339-1.jpg '],
      videos: ['4VhxvHBTZkQ']
    },
    {
      title: 'Structural Concepts FreshWatch™',
      number: 6,
      coordinates: {
        top: '43%',
        left: '44%'
      },
      link: 'https://djnnwndagrfti.cloudfront.net/resources/Shared/FreshWatch-Flyer.pdf ',
      linkTitle: 'Learn More',
      content: toParagraph('FreshWatch™ is an advanced cloud-based platform that gives operators complete visibility into their equipment performance through real-time monitoring, remote diagnostics, and energy optimization. Proactive alerts and actionable insights help protect food quality, reduce waste, minimize downtime, and lower operating costs, empowering businesses to operate more efficiently and profitably.'),
      videos: ['EzBs2f1soKw']
    },
  ]
};

const slides = [
  slideOne,
  slideTwo,
  slideThree,
  slideFour,
  slideFive,
  slideSix,
  slideSeven,
  slideEight,
];


export const slideData = slides.map((slide, parentIndex) => ({
  ...slide,
  hotspots: slide.hotspots.map(hotspot => ({
    ...hotspot,
    parentIndex
  }))
}));
